// extracted by mini-css-extract-plugin
module.exports = {"divCard":"box-proportion_divCard_2s2Tv","title":"box-proportion_title_2wTut"};